import { CreateFocusCss } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import type { PopoverCloseProps } from '..'

export default (config: {
  tokens: Tokens
  props: Pick<PopoverCloseProps, 'dark' | 'scrim'>
}) => {
  const { tokens, props } = config
  const { dark, scrim } = props

  return {
    default: {
      wrap: {
        ...(scrim && {
          backgroundColor: dark
            ? tokens.bgColorPopoverCloseInverse
            : tokens.bgColorPopoverClose,
          borderRadius: tokens.radiusSizeXS,
        }),

        ...(dark && {
          button: {
            '&:hover': {
              backgroundColor: tokens.dark.ctaBgColorTertiaryHover,
            },
            '&:active': {
              backgroundColor: tokens.dark.ctaBgColorTertiaryActive,
            },
            ...CreateFocusCss({
              outlineColor: tokens.iconColorInverse,
            }),

            svg: {
              fill: tokens.iconColorInverse,
            },
          },
        }),
      },
    },
  } as const
}
